export default {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    INTERNAL_SEVER_ERROR: 500
}